export { default } from './Terms';
